export default ([attribute, value], update) =>
  model => {
    if (model[attribute] === value) {
      return update(model)
    }

    return model
  }
